export const view = {
    root: "",
    equipments: "equipments",
    massecuite: "massecuite-processing",
    contacts: "contacts",
    about: "about"
};